import actions from './actions';

const initState = {
    simSwapMessage: null,
    simSwapLoading: false,
    simSwapError: null,
    simSwapFResult: [],

    mdnSwapMessage: null,
    mdnSwapLoading: false,
    mdnSwapError: null,
    mdnSwapFResult: [],
}

export default function reducer(state = initState, action) {
    switch (action.type) {
        case actions.SIM_SWAP:
            return {
                ...state,
                simSwapMessage: null,
                simSwapLoading: true,
                simSwapError: null,
                simSwapFResult: [],
            };

        case actions.SIM_SWAP_SUCCESS:
            return {
                ...state,
                simSwapLoading: false,
                simSwapMessage: action.message,
                simSwapError: null,
            };

        case actions.SIM_SWAP_FAILED:
            return {
                ...state,
                simSwapLoading: false,
                simSwapError: action.payload.error,
                simSwapFResult: action.payload.fResult,
            };

        case actions.MDN_SWAP:
            return {
                ...state,
                mdnSwapMessage: null,
                mdnSwapLoading: true,
                mdnSwapError: null,
                mdnSwapFResult: [],
            };

        case actions.MDN_SWAP_SUCCESS:
            return {
                ...state,
                mdnSwapLoading: false,
                mdnSwapMessage: action.message,
                mdnSwapError: null,
            };

        case actions.MDN_SWAP_FAILED:
            return {
                ...state,
                mdnSwapLoading: false,
                mdnSwapError: action.payload.error,
                mdnSwapFResult: action.payload.fResult,
            };

        case actions.RESET_MESSAGE:
            return {
                ...state,
                simSwapMessage: null,
                simSwapError: null,
                simSwapFResult: [],

                mdnSwapMessage: null,
                mdnSwapError: null,
                mdnSwapFResult: [],
            };

        default:
            return state;
    }
}